import { Component } from '@angular/core';

@Component({
  selector: 'app-missionandvision',
  imports: [],
  templateUrl: './missionandvision.component.html',
  styleUrl: './missionandvision.component.scss'
})
export class MissionandvisionComponent {

}
